import { blackListedNumbers } from "./consts"

export const valutaDisplay = (input:number): string =>
  Intl.NumberFormat('nl-NL', {
    style: 'currency',
    currency: 'EUR',
  }).format(input)

export const isNonBlacklistedPhone = (phone: string | undefined): boolean => {
  const blacklisted = blackListedNumbers.includes(phone || "")
  return !blacklisted
}

export const convertPathToUrl = (path: string, params?: Record<string, string>) => {
  const url = new URL(window.document.URL)

  url.pathname = path
  url.search = ''
  if (params) Object.entries(params).forEach(([key, value]) => url.searchParams.set(key, value))

  return url.toString()
}

export const generateTransactionId = (): string => {
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80
  const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}
